import React, { useEffect } from 'react';

// Contact Section Component - Clean & Simple Version
const Contact = () => {
  useEffect(() => {
    // Load Typeform script
    const script = document.createElement("script");
    script.src = "//embed.typeform.com/next/embed.js";
    script.async = true;
    document.body.appendChild(script);
    
    return () => {
      // Clean up script when component unmounts
      if (document.body.contains(script)) {
        document.body.removeChild(script);
      }
    };
  }, []);

  return (
    <section id="contact" className="py-20 bg-gray-100">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        
        {/* Header Section */}
        <div className="text-center mb-12">
          <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">
            Contact Us
          </h1>
          <h2 className="text-xl md:text-2xl text-gray-700 mb-4">
            Interested in partnering with{' '}
            <span className="font-bold">Banner Day Threads?</span>
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto mb-8">
            Please fill out the form and one of our team members will be in contact
            soon! We specialize in premium custom headwear with low minimums and quick turnarounds.
          </p>
        </div>

        {/* Simple Typeform Button Container */}
        <div className="text-center">
          <div 
            data-tf-live="01JVCQRKJF8MEZD1PD16JT7NQQ"
            aria-label="Contact form for Banner Day Threads custom headwear inquiries"
          />
        </div>
        
      </div>
    </section>
  );
};

export default Contact;